export function setNodeStyle(nodes, transform) {
    for (const node of nodes) {
        const style = transform(node)
        node.data = {...node.data, style}
    }

    this.logger.info('已设置节点样式', nodes)
}
